<div class="main-content">
  <div class="main-header">{{title}}</div>
  <div class="mt20">
          <button mat-stroked-button class="button-style" [ngStyle]="{'border-color' : selectTab == 'select'? 'black':''}" [disabled]="selectTab != 'select'">Select</button>
          <span>
            <svg width="110" height="13" viewBox="0 0 110 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M108.898 5.94911L98.8697 0.721892C98.7101 0.639999 98.5195 0.688787 98.4084 0.843861C98.2966 0.998935 98.2927 1.21935 98.3992 1.37878L101.697 6.34463L98.3992 11.3105C98.2927 11.4699 98.2966 11.6912 98.4077 11.8454C98.4825 11.9508 98.5943 12.0074 98.7077 12.0074C98.7625 12.0074 98.8173 11.9944 98.869 11.9674L108.897 6.74016C109.035 6.66872 109.122 6.51452 109.122 6.34463C109.122 6.17475 109.035 6.02054 108.898 5.94911Z" fill="black"/>
              <rect x="-9.15527e-05" y="5.22168" width="104" height="2" rx="1" fill="black"/>
              </svg>
          </span>

          <button mat-stroked-button class="button-style" [ngStyle]="{'border-color' : selectTab == 'submit'? 'black':''}" [disabled]="selectTab != 'submit'">Submit</button>
          <span>
            <svg width="110" height="13" viewBox="0 0 110 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M108.898 5.94911L98.8697 0.721892C98.7101 0.639999 98.5195 0.688787 98.4084 0.843861C98.2966 0.998935 98.2927 1.21935 98.3992 1.37878L101.697 6.34463L98.3992 11.3105C98.2927 11.4699 98.2966 11.6912 98.4077 11.8454C98.4825 11.9508 98.5943 12.0074 98.7077 12.0074C98.7625 12.0074 98.8173 11.9944 98.869 11.9674L108.897 6.74016C109.035 6.66872 109.122 6.51452 109.122 6.34463C109.122 6.17475 109.035 6.02054 108.898 5.94911Z" fill="black"/>
              <rect x="-9.15527e-05" y="5.22168" width="104" height="2" rx="1" fill="black"/>
              </svg>
          </span>

          <button mat-stroked-button class="button-style" [ngStyle]="{'border-color' : selectTab == 'load'? 'black':''}" [disabled]="selectTab != 'load'">Extract</button>
        </div>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
